export default {
  name: 'Exhibition process',
  item1: '1.Submit the business license of the company',
  item2: '2.Submit product picture and name',
  item3: '3.Receive exhibition presentation documents and booth drawings',
  item4: '4.Submit booth application form/Sign booth contract',
  item5: '5.Pay the contract booth deposit',
  item6: '6.Prepare for exhibition'
}
